import React, { useMemo } from 'react';

import {
	PromptSuggestions,
	type PromptSuggestionsProps,
} from '@atlassian/conversation-assistant/controllers/prompt-suggestions/PromptSuggestions';

import { fg } from '@confluence/feature-gating';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

export type ConfluencePromptSuggestionsProps = Pick<PromptSuggestionsProps, 'children'> & {
	touchpointSource: string;
};

export const ConfluencePromptSuggestions = ({
	touchpointSource,
	children,
}: ConfluencePromptSuggestionsProps): React.JSX.Element => {
	const { cloudId, isRovoEnabled } = useSessionData();
	const assistanceServiceParams = useMemo<PromptSuggestionsProps['assistanceServiceParams']>(
		() => ({
			product: 'confluence',
			experienceId: 'confluence-smart-create',
			touchpointSource,
			siteId: cloudId,
		}),
		[cloudId, touchpointSource],
	);
	return (
		<PromptSuggestions
			includeThirdParty={isRovoEnabled || !fg('rovo_chat_3p_prompt_entitlement_guard')}
			assistanceServiceParams={assistanceServiceParams}
		>
			{children}
		</PromptSuggestions>
	);
};
